export class ImagemGrupo {
    constructor(id = 0, nome = '', tamanho = 0, arquivo = null) {
        this.id = id;
        this.nome = nome;
        this.tamanho = tamanho;
        this.arquivo = arquivo;
    }
}
